// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator calendar`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'
import employees from 'modules/employees/store/collections/employees'
import features from 'modules/core/store/collections/features'
import locations from 'modules/locations/store/collections/locations'
import timeoffPolicies from 'modules/timeoff/store/collections/timeoffPolicies/policies'
import teams from 'modules/teams/store/collections/teams'
import users from 'modules/core/store/collections/users'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companyHolidays, {}] /* Referenced by 13 cases in this module */,
    [employees, {}] /* Referenced by 11 cases in this module */,
    [features, {}] /* Referenced by 32 cases in this module */,
    [locations, {}] /* Referenced by 1 cases in this module */,
    [teams, {}] /* Referenced by 3 cases in this module */,
    [timeoffPolicies, {}] /* Referenced by 1 cases in this module */,
    [users, {}] /* Referenced by 5 cases in this module */,
  ] /* Generated file 👉 artifacts/calendar-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
